var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('h1',{staticClass:"heading"},[_vm._v("404 - Page Not Found")]),_c('p',{staticClass:"paragraph"},[_vm._v("Sorry, the page you're looking for doesn't exist.")]),_c('b-button',{staticClass:"go-home-btn",attrs:{"variant":"cta","size":"lg"},on:{"click":_vm.goHome}},[_vm._v("Go to Home")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }